module.exports = __webpack_public_path__ + "static/img/ranking2.813be6a6.png";